import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { navtoggle } from "../../../store/actions/AuthActions";
import { ThemeContext } from "../../../context/ThemeContext";

/// images
import logo from "../../../images/logo-white.png";
import logoText from "../../../images/logo-text-white.png";
import { getProfile } from "../../../services/AuthService";

const NavHeader = ({ openSidebar }) => {
  const { openMenuToggle } = useContext(ThemeContext);

  const dispatch = useDispatch();
  const sideMenu = useSelector((state) => state.sideMenu);
  const [hasDashboardMenu, setHasDashboardMenu] = useState(true);
  useEffect(() => {
    const fetchProfile = async ()=>{
      const profile = await getProfile();
      if (profile && profile.data && profile.data.allowedModules) {
        const hasDashboard = profile.data.allowedModules.some(
          (module) =>
            module.value.trim() === "dashboard" &&
            module.operations.includes("menu")
        );
        if (hasDashboard === false) {
          setHasDashboardMenu(false);
        }
      }
    }
    fetchProfile();
    
  }, []);
  const handleToogle = () => {
    dispatch(navtoggle());
  };
  return (
    <div className="nav-header">
      {hasDashboardMenu === true ? (
        <Link to="/dashboard" className="brand-logo">
          <img className="logo-abbr" src={logo} alt="" />
          <img className="logo-compact" src={logoText} alt="" />
          <img className="brand-title" src={logoText} alt="" />
        </Link>
      ) : (
        <Link to="/forms" className="brand-logo">
          <img className="logo-abbr" src={logo} alt="" />
          <img className="logo-compact" src={logoText} alt="" />
          <img className="brand-title" src={logoText} alt="" />
        </Link>
      )}

      <div
        className="nav-control"
        onClick={() => {
          handleToogle();
          openMenuToggle();
        }}
      >
        <div
          className={`hamburger ${sideMenu ? "is-active" : ""} ${
            openSidebar ? "d-none" : ""
          }`}
        >
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
      </div>
    </div>
  );
};

export default NavHeader;
